export const GET_SOCIAL_CHANNEL_TYPES_QUERY = `
    query SocialChannelTypes {
        socialChannelTypes
    }
`;
export const GET_ICARUS_MULTIPART_CONFIG = ` 
    query IcarusMultipartConfig {
        icarusMultipartConfig {
            icarus_server
            aws_key
            bucket
            maxConcurrentParts
            maxRetryBackoffSecs
            partSize
            retryBackoffPower
        }
    } 
`;
export const GET_ENUMS_QUERY = `
    query GetEnums($name: EnumsEnum!) {
        getEnums(name: $name)
    }
`;
